// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"fe5e3b81","453":"a031096f","648":"56e1863e"}[chunkId] + ".chunk.js";
};